/**
 * 忘记密码页面
 */
import './index.less';

import { FC } from 'react';

import { useI18nContext } from '@/i18n/I18n';

import LazyEntry from './lazyEntry';

const Retrieve: FC = () => {
  const [$t] = useI18nContext();

  return (
    <div className="retrieve-container">
      <div className="cardContainer">
        <div data-paint className="title">
          {$t('Reset Password')}
        </div>
        <LazyEntry />
      </div>
    </div>
  );
};

export default Retrieve;
